// client/src/components/ScrollToTop.jsx (Enhanced Version)
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronUp } from 'lucide-react';

const ScrollToTop = ({ showScrollButton = true, offset = 100 }) => {
    const { pathname, hash, key } = useLocation();
    const [isVisible, setIsVisible] = useState(false);

    // Handle route changes
    useEffect(() => {
        // If there's a hash in the URL (like #section), scroll to that element
        if (hash) {
            const element = document.getElementById(hash.replace('#', ''));
            if (element) {
                // Small delay to ensure the page has rendered
                setTimeout(() => {
                    const elementTop = element.offsetTop - offset;
                    window.scrollTo({
                        top: elementTop,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 100);
            }
        } else {
            // Otherwise, scroll to top of page
            // Small delay to ensure the route has changed
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 100);
        }
    }, [pathname, hash, key, offset]);

    // Handle scroll button visibility
    useEffect(() => {
        if (!showScrollButton) return;

        const toggleVisibility = () => {
            // Show button when user scrolls down 300px
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, [showScrollButton]);

    // Scroll to top function for the button
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            {/* Scroll to Top Button */}
            {showScrollButton && isVisible && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-8 right-8 z-50 p-3 bg-blue-600 text-white rounded-full shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-300 transform hover:scale-110"
                    aria-label="Scroll to top"
                    type="button"
                >
                    <ChevronUp className="h-6 w-6" />
                </button>
            )}
        </>
    );
};

export default ScrollToTop;